export default __webpack_public_path__ + "static/media/xtreme-project-3.6101ca64.webp";